import { Vec2, PageView } from 'cc';

declare module 'cc' {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    interface PageView {
        // Whether turn serveral pages by one drag
        _pagesDragTurnable: boolean;
        pagesDragTurnable: boolean;
    }
}

// @ts-ignore
const originalDragDirection = PageView.prototype._getDragDirection;

// @ts-ignore
// reference: https://forum.cocos.org/t/topic/124320
PageView.prototype._getDragDirection = function _getDragDirection(this: PageView, moveOffset: Vec2) {
    if (!this.pagesDragTurnable) {
        return originalDragDirection.call(this, moveOffset);
    }

    const locPages = this._pages;
    const cur = this._curPageIdx;
    // Horizontal
    if (this._direction === PageView.Direction.Horizontal) {
        let dist = moveOffset.x;
        let of = 0;
        const d = dist > 0 ? 1 : -1;
        while (dist !== 0) {
            const p = locPages[cur + of].getPosition();
            const q = locPages[cur + of + d]?.getPosition();
            if (!q) {
                break;
            }
            const sc = locPages[cur + of].getScale();
            let sp = Math.abs(q.x - p.x);
            let u = locPages[cur + of]._uiProps.uiTransformComp;
            const w = (d > 0 ? 1 - u.anchorX : u.anchorX) * u.width * sc.x;
            sp -= w;
            dist -= w * d;
            if (dist * d <= 0) {
                break;
            }
            of += d;
            u = locPages[cur + of]._uiProps.uiTransformComp;
            if (!u) break;
            // w = (d>0? u.anchorX : 1- u.anchorX ) * u.width;
            dist -= sp * d;
            if (dist * d <= 0) {
                break;
            }
        }
        return of;
    }

    // Vertical
    let dist = -moveOffset.y;
    let of = 0;
    const d = dist > 0 ? 1 : -1;
    while (dist !== 0) {
        const p = locPages[cur + of].getPosition();
        const q = locPages[cur + of + d]?.getPosition();
        if (!q) {
            break;
        }
        const sc = locPages[cur + of].getScale();
        let sp = Math.abs(q.y - p.y);
        let u = locPages[cur + of]._uiProps.uiTransformComp;
        const h = (d > 0 ? 1 - u.anchorY : u.anchorY) * u.height * sc.y;
        sp -= h;
        dist -= h * d;
        if (dist * d <= 0) {
            break;
        }
        of += d;
        u = locPages[cur + of]._uiProps.uiTransformComp;
        if (!u) break;
        // w = (d>0? u.anchorX : 1- u.anchorX ) * u.width;
        dist -= sp * d;
        if (dist * d <= 0) {
            break;
        }
    }
    return of;
};

Object.defineProperty(PageView.prototype, 'pagesDraggable', {
    configurable: true,
    get(this: PageView) {
        return this._pagesDragTurnable;
    },
    set(this: PageView, value: boolean) {
        if (this._pagesDragTurnable === value) {
            return;
        }
        this._pagesDragTurnable = value;
    },
});
